/**
 * MY — Allotment of Shares (Otherwise Than Cash, M32202) Register Detail 매핑.
 *
 * TASK_DATA.formData 구조 (PreSetAllotmentOtcPanel.gatherState → officerData.presetForm):
 *   { state:{values,flags,choices,...}, allottees:[{allottee_name,allottee_address,allottee_shares,...}],
 *     companyName, companyRegistrationNo, sharePrice, subscriberType }
 *   → registry 가 presetForm 을 상위로 병합하므로 companyName/allottees 등을 그대로 참조.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32202', {
  title: 'Allotment of Shares (OTC) Details',
  repeatArrayPath: 'allottees',
  fields: [
    { label: 'Company Name', key: ['companyName', 'company_name'] },
    { label: 'Registration No.', key: ['companyRegistrationNo', 'company_registration_no'] },
    { label: 'Share Price (RM)', key: ['sharePrice', 'share_price'] },
    // Allottee 행별
    { label: 'Allottee', key: ['allottees.0.allottee_name'] },
    { label: 'Address', key: ['allottees.0.allottee_address'] },
    { label: 'No. of Shares', key: ['allottees.0.allottee_shares'] },
  ],
});
